import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import './createSource.css';

class CreateSourceComponent extends React.Component {
    
    constructor(props){

        super(props);

        this.state = {
            link: ''
        }

        this.canSave = this.canSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.renderLink = this.renderLink.bind(this);
    }

    canSave(){
        if(this.state.link.trim().length>0){
            return true;
        }
        return false;
    }

    createSource(){
        let link = this.state.link.trim();
        if(link.length>0){
            let source = {
                link: link,
                text: ''
            }
            this.props.createSource(source);
            this.props.toggleCreateSource();
        }
    }

    handleChange(event, type, index){
        if(type=="link"){
            let link = this.state.link;
            link = event.target.value;
            this.setState({link: link});
        }
    }

    renderLink(){

        return (
            <div style={{marginTop:'5px', textAlign:'left'}}>
                <form>
                    <label>
                        <TextField 
                            type="text"
                            variant="outlined"
                            multiline
                            placeholder = "Source name or url"
                            value={this.state.link}
                            onChange={(e) => { this.handleChange(e,"link")}}
                            rowsMax="3"
                            rowsMin="1"
                            style={{
                                background: 'white',
                                marginTop:'6px',
                                marginBottom:'6px',
                                width:'95%',
                                margin:'1em'
                                }}/>
                    </label>
                </form>
            </div>
        )
    }

    render(){
        
        return (
            <div style={{marginLeft:'1em', border:'0.5px solid grey', marginRight:'1em'}}>

                <p> Create Source</p>
                {this.renderLink()}

                <div style={{display:'flex', flexWrap:'wrap', marginBottom:'10px', marginLeft:'1em'}}>
                    <div>
                        <Button 
                            color="primary"
                            variant="contained"
                            className="genericButton_v1" 
                            onClick={() => {this.props.toggleCreateSource()}}>                                
                                    <div>Cancel</div>
                        </Button>
                    </div>   
                    {this.canSave()?
                        <div>
                            <Button 
                                color="primary"
                                variant="contained"
                                className="genericButton_v1" 
                                onClick={() => {this.createSource()}}>                                
                                        <div>Create</div>
                            </Button>
                        </div>
                        :
                        null
                    }
                </div>

            </div>
        )
    }
}
export default CreateSourceComponent;